<app-modal-template
	[title]="title"
	(cancelClicked)="cancel()"
	(saveClicked)="uploadTemplate()"
	[showCancel]="false"
	[saveText]="'Upload'"
	[saveIcon]="['fass', 'arrow-from-bottom']"
>
	<form [formGroup]="form">
		<!-- User Type -->
		<div class="instruction-step">
			<div>1.User Type</div>
			<mat-radio-group formControlName="userType">
				<mat-radio-button value="{{ azure_string }}">{{ azure_string }}</mat-radio-button>
				<mat-radio-button value="{{ local_string }}">{{ local_string }}</mat-radio-button>
			</mat-radio-group>
			<mat-error class="error" *ngIf="form.get('userType')?.touched && form.get('userType')?.errors?.required">
				User Type is required
			</mat-error>
		</div>

		<!-- Download Template  -->
		<div class="instruction-step">
			<div>2. Download .CSV template</div>
			<app-progress-button
				id="download-csv-template"
				class="step-button"
				color="primary"
				[icon]="$any(['fass', 'arrow-to-bottom'])"
				[buttonText]="'Download'"
				[working]="downloading"
				[disabled]="uploading"
				(click)="downloadTemplate()"
			></app-progress-button>
		</div>

		<!-- Edit Instructions -->
		<div class="instruction-step">
			<div>
				3. Open the template and add users to the file
				<ul>
					<li>Leave the header row in the template and add your users (1 per row) underneath</li>
					<li>Fields with an * next to them are required fields</li>
					<li>
						You can specify more than one role by including a | between role names (ex.
						CSR|Reviewer|Surveyor)
					</li>
				</ul>
			</div>
		</div>

		<!-- Choose File Upload -->
		<div class="instruction-step">
			<div>4. Choose the file then click Upload</div>
			<button mat-raised-button class="step-button" (click)="fileUpload.click()" *ngIf="!form.get('file').value">
				<fa-icon [icon]="$any(['fass', 'file'])" [fixedWidth]="true"></fa-icon>
				Choose File
			</button>
			<div class="file-name" *ngIf="form.get('file').value">
				{{ form.get('file').value.name }}
				<fa-icon
					[icon]="$any(['fass', 'trash'])"
					class="file-name-delete"
					[fixedWidth]="true"
					(click)="clearFile()"
					title="Remove File"
					[ngClass]="{ clickable: !uploading }"
				></fa-icon>
			</div>
			<input
				type="file"
				#fileUpload
				id="fileUpload"
				name="fileUpload"
				accept=".csv"
				(change)="fileSelected()"
				style="display: none"
			/>
			<mat-error class="error" *ngIf="form.get('file').touched && form.get('file')?.errors?.required">
				Upload File is required
			</mat-error>
		</div>
	</form>
</app-modal-template>
